import { delayCall } from "./DelayCall.js";
/**
 *
 */
class DestroyOptions {
  constructor() {
    this.delay = 0;
  }
}

/**
 *
 */
const DefaultDestroyOptions = new DestroyOptions();

/**
 *
 * @param {*} scene
 * @param {*} runtime
 * @returns
 */
const destroy =
  (caller, runtime) =>
  (obj, options = DefaultDestroyOptions) => {
    if (obj !== undefined && obj !== null) {
      const removeFromScene = () => {
        if (obj.traverse === 'function') {
          obj.traverse(node => {
            // TODO: Improve this using type check
            if (node.code) {
              runtime.unregisterBehaviourNode(node);
            }
          });
        }
        // obj.removeFromParent();
        caller.remove(obj);
      };

      if (options?.delay > 0) {
        delayCall(removeFromScene, options?.delay);
      } else {
        removeFromScene();
      }
    } else {
      throw new Error('Invalid object to destroy');
    }
  };

export { destroy };
